import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, HostBinding, Input, NgModule } from '@angular/core';
import { BaseDirective } from '@eui/components/shared';
import { CommonModule } from '@angular/common';

class EuiFeedbackMessageComponent extends BaseDirective {
    constructor() {
        super();
        this.type = 'MessageFeedback';
    }
    get cssClasses() {
        return [
            super.getCssClasses('eui-feedback-message'),
            this.styleClass ? this.styleClass : ''
        ].join(' ').trim();
    }
}
/** @nocollapse */ EuiFeedbackMessageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiFeedbackMessageComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ EuiFeedbackMessageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: EuiFeedbackMessageComponent, selector: "eui-feedback-message", inputs: { styleClass: "styleClass" }, host: { properties: { "class": "this.cssClasses", "attr.type": "this.type" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [".eui-feedback-message{font: 400 .875rem/1rem arial,sans-serif;color:var(--eui-base-color-grey-100);margin-top:var(--eui-base-spacing-xs);position:relative}.eui-feedback-message--info{color:var(--eui-base-color-info-100)}.eui-feedback-message--success{color:var(--eui-base-color-success-100)}.eui-feedback-message--warning{color:var(--eui-base-color-warning-140)}.eui-feedback-message--danger{color:var(--eui-base-color-danger-100)}\n"], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiFeedbackMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'eui-feedback-message', template: '<ng-content></ng-content>', encapsulation: ViewEncapsulation.None, styles: [".eui-feedback-message{font: 400 .875rem/1rem arial,sans-serif;color:var(--eui-base-color-grey-100);margin-top:var(--eui-base-spacing-xs);position:relative}.eui-feedback-message--info{color:var(--eui-base-color-info-100)}.eui-feedback-message--success{color:var(--eui-base-color-success-100)}.eui-feedback-message--warning{color:var(--eui-base-color-warning-140)}.eui-feedback-message--danger{color:var(--eui-base-color-danger-100)}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { cssClasses: [{
                type: HostBinding,
                args: ['class']
            }], styleClass: [{
                type: Input
            }], type: [{
                type: HostBinding,
                args: ['attr.type']
            }] } });

class EuiFeedbackMessageModule {
}
/** @nocollapse */ EuiFeedbackMessageModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiFeedbackMessageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ EuiFeedbackMessageModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: EuiFeedbackMessageModule, declarations: [EuiFeedbackMessageComponent], imports: [CommonModule], exports: [EuiFeedbackMessageComponent] });
/** @nocollapse */ EuiFeedbackMessageModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiFeedbackMessageModule, imports: [CommonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiFeedbackMessageModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                    ],
                    declarations: [
                        EuiFeedbackMessageComponent,
                    ],
                    exports: [
                        EuiFeedbackMessageComponent,
                    ],
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { EuiFeedbackMessageComponent, EuiFeedbackMessageModule };
